module.exports = [
	{
		"id": "30339001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30339001/640/30339001.jpg",
		"headline": "GROHE Red Mono",
		"subheadline": "Výpusť ve tvaru písmene C, velikost M",
		"textblock_1st_text": "30339001",
		"textblock_2nd_text": "Kuchyňská baterie GROHE RED Mono (výpusť ve tvaru písmene L) s filtrační sadou a bojlerem velikosti M pro okamžitou vařící vodu. Chromový povrch. Energetická efektivita třídy A a bezpečnostní technologie",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/30339001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nash-servis/shou-rumy-installjatory.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30327001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30327001/640/30327001.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Výpusť a bojler velikosti M",
		"textblock_1st_text": "30327001",
		"textblock_2nd_text": "Kuchyňská baterie GROHE RED Duo (výpusť ve tvaru písmene L) s filtrační sadou a bojlerem velikosti M pro okamžitou vařící vodu. Chromový povrch. Energetická efektivita třídy A a bezpečnostní technologie",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/30327001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nash-servis/shou-rumy-installjatory.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30325001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30325001/640/30325001.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Výpusť a bojler, velikost L",
		"textblock_1st_text": "30325001",
		"textblock_2nd_text": "Kuchyňská baterie GROHE RED Duo (výpusť ve tvaru písmene L) s filtrační sadou a bojlerem velikosti L pro okamžitou vařící vodu. Chromový povrch. Energetická efektivita třídy A a bezpečnostní technologie",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/30325001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nash-servis/shou-rumy-installjatory.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30085001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30085001/640/30085001.jpg",
		"headline": "GROHE Red Mono",
		"subheadline": "Výpusť ve tvaru písmene C, velikost M",
		"textblock_1st_text": "30085001",
		"textblock_2nd_text": "Kuchyňská baterie GROHE RED Mono (výpusť ve tvaru písmene C) s filtrační sadou a bojlerem velikosti M pro okamžitou vařící vodu. Chromový povrch. Energetická efektivita třídy A a bezpečnostní technologie",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/30085001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nash-servis/shou-rumy-installjatory.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30083001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30083001/640/30083001.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Výpusť a bojler velikosti M",
		"textblock_1st_text": "30083001",
		"textblock_2nd_text": "Kuchyňská baterie GROHE RED Duo (výpusť ve tvaru písmene C) s filtrační sadou a bojlerem velikosti M pro okamžitou vařící vodu. Chromový povrch. Energetická efektivita třídy A a bezpečnostní technologie",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/30083001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nash-servis/shou-rumy-installjatory.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30079001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30079001/640/30079001.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Výpusť a bojler, velikost L",
		"textblock_1st_text": "30079001",
		"textblock_2nd_text": "Kuchyňská baterie GROHE RED Duo (výpusť ve tvaru písmene C) s filtrační sadou a bojlerem velikosti L pro okamžitou vařící vodu. Chromový povrch. Energetická efektivita třídy A a bezpečnostní technologie",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/30079001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nash-servis/shou-rumy-installjatory.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "40841001",
		"image": "//cdn.cloud.grohe.com/prod/40/40/40841001/640/40841001.jpg",
		"headline": "GROHE Red",
		"subheadline": "Mixing valve",
		"textblock_1st_text": "40841001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/40841001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nash-servis/shou-rumy-installjatory.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31454DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31454DC0/640/31454DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Startovní sada s výpustí ve tvaru L",
		"textblock_1st_text": "31454DC0",
		"textblock_2nd_text": "Úvodní sada GROHE Blue Home Duo: páková kuchyňská baterie pro filtrovanou, chlazenou a perlivou vodu. Včetně chladiče, filtru a CO2 karbonizační lahve. Vysoká výpusť ve tvaru písmene L a povrchová úprava z nerezové oceli.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/31454DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nash-servis/shou-rumy-installjatory.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31455000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31455000/640/31455000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Startovní sada s výpustí ve tvaru C",
		"textblock_1st_text": "31455000",
		"textblock_2nd_text": "Úvodní sada GROHE Blue Home Duo: páková kuchyňská baterie pro filtrovanou, chlazenou a perlivou vodu. Včetně chladiče, filtru a CO2 karbonizační lahve. Vysoká výpusť ve tvaru písmene C, chromový povrch.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/31455000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nash-servis/shou-rumy-installjatory.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31455DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31455DC0/640/31455DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Startovní sada s výpustí ve tvaru C",
		"textblock_1st_text": "31455DC0",
		"textblock_2nd_text": "Úvodní sada GROHE Blue Home Duo: páková kuchyňská baterie pro filtrovanou, chlazenou a perlivou vodu. Včetně chladiče, filtru a CO2 karbonizační lahve. Vysoká výpusť ve tvaru písmene C a povrchová úprava z nerezové oceli.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/31455DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nash-servis/shou-rumy-installjatory.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30327DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30327DC1/640/30327DC1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Výpusť a bojler velikosti M",
		"textblock_1st_text": "30327DC1",
		"textblock_2nd_text": "Kuchyňská baterie GROHE RED Duo (výpusť ve tvaru písmene L) s filtrační sadou a bojlerem velikosti M pro okamžitou vařící vodu. Matný povrch z nerezové oceli. Energetická efektivita třídy A a bezpečnostní technologie",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/30327DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nash-servis/shou-rumy-installjatory.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30325DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30325DC1/640/30325DC1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Výpusť a bojler, velikost L",
		"textblock_1st_text": "30325DC1",
		"textblock_2nd_text": "Kuchyňská baterie GROHE RED Duo (výpusť ve tvaru písmene L) s filtrační sadou a bojlerem velikosti L pro okamžitou vařící vodu. Matný povrch z nerezové oceli. Energetická efektivita třídy A a bezpečnostní technologie",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/30325DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nash-servis/shou-rumy-installjatory.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30083DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30083DC1/640/30083DC1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Výpusť a bojler velikosti M",
		"textblock_1st_text": "30083DC1",
		"textblock_2nd_text": "Kuchyňská baterie GROHE RED Duo (výpusť ve tvaru písmene C) s filtrační sadou a bojlerem velikosti M pro okamžitou vařící vodu. Matný povrch z nerezové oceli. Energetická efektivita třídy A a bezpečnostní technologie",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/30083DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nash-servis/shou-rumy-installjatory.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30080001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30080001/640/30080001.jpg",
		"headline": "GROHE Red Mono",
		"subheadline": "Výpusť ve tvaru písmene C, velikost L",
		"textblock_1st_text": "30080001",
		"textblock_2nd_text": "Kuchyňská baterie GROHE RED Mono (výpusť ve tvaru písmene C) s filtrační sadou a bojlerem velikosti L pro okamžitou vařící vodu. Chromový povrch. Energetická efektivita třídy A a bezpečnostní technologie",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/30080001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nash-servis/shou-rumy-installjatory.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30079DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30079DC1/640/30079DC1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Výpusť a bojler, velikost L",
		"textblock_1st_text": "30079DC1",
		"textblock_2nd_text": "Kuchyňská baterie GROHE RED Duo (výpusť ve tvaru písmene C) s filtrační sadou a bojlerem velikosti L pro okamžitou vařící vodu. Matný povrch z nerezové oceli. Energetická efektivita třídy A a bezpečnostní technologie",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/30079DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nash-servis/shou-rumy-installjatory.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31498000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31498000/640/31498000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Startovní sada Mono",
		"textblock_1st_text": "31498000",
		"textblock_2nd_text": "Úvodní sada GROHE Blue Home Mono: stojánková baterie pro filtrovanou, chlazenou a perlivou vodu. Včetně chladiče, filtru a CO2 karbonizační lahve. Vysoká výpusť ve tvaru písmene C, chromový povrch.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/31498000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nash-servis/shou-rumy-installjatory.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31498DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31498DC0/640/31498DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Startovní sada Mono",
		"textblock_1st_text": "31498DC0",
		"textblock_2nd_text": "Úvodní sada GROHE Blue Home Mono: stojánková baterie pro filtrovanou, chlazenou a perlivou vodu. Včetně chladiče, filtru a CO2 karbonizační lahve. Vysoká výpusť ve tvaru písmene C a povrchová úprava z nerezové oceli.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/31498DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nash-servis/shou-rumy-installjatory.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31456000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31456000/640/31456000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Startovní sada s výpustí ve tvaru U",
		"textblock_1st_text": "31456000",
		"textblock_2nd_text": "Úvodní sada GROHE Blue Home Duo: páková kuchyňská baterie pro filtrovanou, chlazenou a perlivou vodu. Včetně chladiče, filtru a CO2 karbonizační lahve. Vysoká výpusť ve tvaru písmene U, chromový povrch.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/31456000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nash-servis/shou-rumy-installjatory.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31456DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31456DC0/640/31456DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Startovní sada s výpustí ve tvaru U",
		"textblock_1st_text": "31456DC0",
		"textblock_2nd_text": "Úvodní sada GROHE Blue Home Duo: páková kuchyňská baterie pro filtrovanou, chlazenou a perlivou vodu. Včetně chladiče, filtru a CO2 karbonizační lahve. Vysoká výpusť ve tvaru písmene U a povrchová úprava z nerezové oceli.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/31456DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nash-servis/shou-rumy-installjatory.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31454000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31454000/640/31454000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Startovní sada s výpustí ve tvaru L",
		"textblock_1st_text": "31454000",
		"textblock_2nd_text": "Úvodní sada GROHE Blue Home Duo: páková kuchyňská baterie pro filtrovanou, chlazenou a perlivou vodu. Včetně chladiče, filtru a CO2 karbonizační lahve. Vysoká výpusť ve tvaru písmene L, chromový povrch.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/31454000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nash-servis/shou-rumy-installjatory.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/data/water_products_cs_cz.json
// module id = 870
// module chunks = 0